import React, { useState, useEffect } from "react";
import MaterialTable, { MTableToolbar } from "material-table";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import ContentLoader from "react-content-loader";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import authHeader from "../../../services/auth-header";
import { API } from "../../../backend";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Helper from "../../../Helper";
import lineOfBusinessService from "../../../services/company/lineofbusinessService";
import subcompanyService from "../../../services/company/subcompanyService";
import { getTrans as t } from "../../../Localization/translations";

function ManualAccountingReport() {

    const tableRef = React.createRef();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [subcompany, setSubcompany] = useState("");
    const [lineOfBusiness, setLineOfBusiness] = useState("");
    const [subcompanyOptions, setSubcompanyOptions] = useState([]);
    const [lineOfBusinessOptions, setLineOfBusinessOptions] = useState([]);
    const [state1, setState] = useState({ isPaneOpen: false });
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);


    useEffect(() => {
        subcompanyService.getSubcompany().then(res =>
            setSubcompanyOptions(res.data || [])
        );

        lineOfBusinessService.getLineOfBusiness().then(res =>
            setLineOfBusinessOptions(res.data || [])
        );

        setLoading(false);
    }, []);

    return (
        <>
            {loading === false ? (
                <div className="page-wrapper">
                    <div className="container-fluid py-4 pt-2">
                        <div className="row py-2 mt-2"></div>
                        <ToastContainer />


                        <div className="col-md-12">

                            <MaterialTable
                                tableRef={tableRef}
                                style={{
                                    backgroundColor: "var(--bs-table-bg)",
                                    borderBottomWidth: "1px",
                                    boxShadow:
                                        "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                                }}
                                title={<h5 className="mb-0">{t("Manual Accounting Report")}</h5>}

                                columns={[
                                    {
                                        title: t("Accounting Number"),
                                        field: "accounting_number",
                                        headerStyle: { fontWeight: "bold" },
                                        cellStyle: { fontSize: 12 },
                                        render: (rowData) => (
                                            <div
                                                className="hyperlink"
                                                onClick={() =>
                                                    navigate("/viewmanualaccounting", {
                                                        state: rowData.id,
                                                    })
                                                }
                                            >
                                                {rowData.accounting_number}
                                            </div>
                                        ),
                                    },
                                    {
                                        title: t("Entry Date"),
                                        field: "entry_date",
                                        render: row =>
                                            row.entry_date
                                                ? Helper.DateNormal(row.entry_date)
                                                : "",
                                        headerStyle: { fontWeight: "bold" },
                                        cellStyle: { fontSize: 12 },
                                    },
                                    {
                                        title: t("Description"),
                                        field: "description",
                                        headerStyle: { fontWeight: "bold" },
                                        cellStyle: { fontSize: 12 },
                                    },
                                    {
                                        title: t("Debit Account"),
                                        field: "debit_account_name",
                                        headerStyle: { fontWeight: "bold" },
                                        cellStyle: { fontSize: 12 },
                                    },
                                    {
                                        title: t("Credit Account"),
                                        field: "credit_account_name",
                                        headerStyle: { fontWeight: "bold" },
                                        cellStyle: { fontSize: 12 },
                                    },
                                    {
                                        title: t("Reference"),
                                        field: "reference",
                                        headerStyle: { fontWeight: "bold" },
                                        cellStyle: { fontSize: 12 },
                                    },
                                    {
                                        title: t("Sub Company"),
                                        field: "subcompany_name",
                                        headerStyle: { fontWeight: "bold" },
                                        cellStyle: { fontSize: 12 },
                                    },
                                    {
                                        title: t("Line of Business"),
                                        field: "line_of_business_name",
                                        headerStyle: { fontWeight: "bold" },
                                        cellStyle: { fontSize: 12 },
                                    },
                                    {
                                        title: t("Amount"),
                                        field: "amount",
                                        render: row => Helper.Amount(row.amount),
                                        headerStyle: {
                                            fontWeight: "bold",
                                            textAlign: "right",
                                        },
                                        cellStyle: {
                                            textAlign: "right",
                                            fontSize: 12,
                                        },
                                    },
                                    {
                                        title: t("Status"),
                                        field: "status",
                                        headerStyle: { fontWeight: "bold", textAlign: "left" },
                                        cellStyle: { textAlign: "left", fontSize: 12 },
                                    },
                                ]}

                                data={query =>
                                    new Promise(resolve => {

                                        const params = new URLSearchParams();

                                        params.append("per_page", query.pageSize);
                                        params.append("page", Number(query.page) + 1);

                                        params.append("search", query.search || "");

                                        if (subcompany)
                                            params.append("subcompany", subcompany);

                                        if (lineOfBusiness)
                                            params.append("line_of_business", lineOfBusiness);

                                        if (fromDate)
                                            params.append("from_date", Helper.DatePicker(fromDate));

                                        if (toDate)
                                            params.append("to_date", Helper.DatePicker(toDate));

                                        const url = `${API}manualaccounting/?${params.toString()}`;

                                        fetch(url, { headers: authHeader() })
                                            .then(res => res.json())
                                            .then(result => {

                                                const data = result.results || result.data || [];
                                                const total = result.count || result.total || 0;

                                                const currentPage =
                                                    result.current_page ??
                                                    result.page ??
                                                    (query.page + 1);

                                                resolve({
                                                    data: data,
                                                    page: currentPage - 1,   // always safe
                                                    totalCount: total,
                                                });
                                            });

                                    })
                                }


                                localization={{
                                    toolbar: {
                                        searchPlaceholder: "Search Manual Accounting",
                                    },
                                }}

                                components={{
                                    Toolbar: props => (
                                        <div className="MuiToolbar-root MTableToolbar-spacer-21 my-temp-class">
                                            <MTableToolbar {...props} />
                                            <span
                                                onClick={() =>
                                                    setState({ isPaneOpen: true })
                                                }
                                                style={{
                                                    color: "#b4b7c5",
                                                    paddingRight: "10px",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                <img
                                                    src={
                                                        process.env.PUBLIC_URL +
                                                        "/static/images/ic-filter.svg"
                                                    }
                                                    alt=""
                                                />
                                            </span>
                                        </div>
                                    ),
                                }}

                                options={{
                                    headerStyle: {
                                        backgroundColor: "white",
                                        color: "#245C7F",
                                        fontSize: 11,
                                    },
                                    rowStyle: (rowData, index) => ({
                                        backgroundColor:
                                            index % 2 ? "#fff" : "var(--bs-table-accent-bg)",
                                    }),
                                    sorting: true,
                                    search: true,
                                    toolbar: true,
                                    paging: true,
                                    pageSize: 10,
                                    emptyRowsWhenPaging: false,
                                    pageSizeOptions: [10, 20, 25, 50],
                                    paginationType: "stepped",
                                    showFirstLastPageButtons: false,
                                    exportButton: true,
                                    exportFileName: "ManualAccounting",
                                    columnsButton: true,
                                }}
                            />

                            {/* FILTER PANEL */}

                            <SlidingPane
                                className="some-custom-class"
                                overlayClassName="some-custom-overlay-class"
                                isOpen={state1.isPaneOpen}
                                title="Filter By"
                                onRequestClose={() =>
                                    setState({ isPaneOpen: false })
                                }
                            >
                                <div className="col-md-12">
                                    <label className="col-form-label">
                                        {t("Sub Company")}
                                    </label>
                                    <select
                                        className="form-select form-control"
                                        value={subcompany}
                                        onChange={e =>
                                            setSubcompany(e.target.value)
                                        }
                                    >
                                        <option value="">Select Company</option>
                                        {subcompanyOptions.map(sub => (
                                            <option key={sub.id} value={sub.id}>
                                                {sub.sub_company_name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="col-md-12 mt-3">
                                    <label className="col-form-label">
                                        {t("Line of Business")}
                                    </label>
                                    <select
                                        className="form-select form-control"
                                        value={lineOfBusiness}
                                        onChange={e =>
                                            setLineOfBusiness(e.target.value)
                                        }
                                    >
                                        <option value="">
                                            Select Line of Business
                                        </option>
                                        {lineOfBusinessOptions.map(lob => (
                                            <option key={lob.id} value={lob.id}>
                                                {lob.lob_name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="col-md-12 mt-3">
                                    <label className="col-form-label">{t("From Date")}</label>
                                    <DatePicker
                                        className="form-control"
                                        selected={fromDate}
                                        onChange={setFromDate}
                                        placeholderText="mm/dd/yyyy"
                                        showYearDropdown
                                        scrollableYearDropdown
                                        showMonthDropdown
                                        autoComplete="off"
                                        dropdownMode="select"
                                    />
                                </div>

                                <div className="col-md-12 mt-3">
                                    <label className="col-form-label">{t("To Date")}</label>
                                    <DatePicker
                                        className="form-control"
                                        selected={toDate}
                                        onChange={setToDate}
                                        placeholderText="mm/dd/yyyy"
                                        showYearDropdown
                                        scrollableYearDropdown
                                        showMonthDropdown
                                        autoComplete="off"
                                        dropdownMode="select"
                                    />
                                </div>


                                <div className="col-xl-12 mt-4">
                                    <button
                                        className="btn bg-gradient-secondary btn-m"
                                        onClick={() => {
                                            setSubcompany("");
                                            setLineOfBusiness("");
                                            setFromDate(null);
                                            setToDate(null);
                                            tableRef.current.onQueryChange();
                                        }}
                                    >
                                        {t("Reset")}
                                    </button>

                                    <button
                                        className="btn btn-primary btn-m ms-2"
                                        onClick={() =>
                                            tableRef.current.onQueryChange()
                                        }
                                    >
                                        {t("Apply")}
                                    </button>
                                </div>
                            </SlidingPane>

                        </div>
                    </div>
                </div>
            ) : (
                <ContentLoader viewBox="0 0 1000 300" />
            )}
        </>
    );
}

export default ManualAccountingReport;
